(function () {
const $02dc23fb8a033d13$export$aaacef11acc9e4f6 = 48;
const $02dc23fb8a033d13$export$bc90872e265d166e = 10;
const $02dc23fb8a033d13$export$8da1753993efc39a = "99999";
const $02dc23fb8a033d13$export$c995b89fa785e28 = "99998";
const $02dc23fb8a033d13$export$da9e2c336eb0e98e = {
    id: "9346dc6c-f982-48ce-9e21-f6a334b367b3",
    text: "Manifest is a grid-based pinboard for note taking.\n\nSimply click and drag anywhere to create a memo and snap it to the grid. All memos can be moved, resized, deleted and are saved in your browser's local storage between sessions.\n\nTo toggle between dark and light modes you can press Alt + T.\n\nManifest is free and completely open-source, please consider donating. \n\nhttps://donate.stripe.com/cN23ggaU156agSYaEF \n\nIf you find a bug or have a suggestion feel free to file an issue on Github. \n\nhttps://github.com/jonathontoon/manifest/issues",
    position: {
        top: 50,
        left: 50
    },
    size: {
        width: 400,
        height: 380
    }
};



function $afebcb8f06c5af05$export$715f9d76bb8c1fea(a) {
    return window.confirm(a);
}
function $afebcb8f06c5af05$export$5aa524d86254b4f(a, b) {
    return window.localStorage.setItem(`${a}`, JSON.stringify(b));
}
function $afebcb8f06c5af05$export$93d719890ad66653(a) {
    return JSON.parse(window.localStorage.getItem(a));
}
function $afebcb8f06c5af05$export$195604d042fd3f87(a, b) {
    return b * Math.round(a / b);
}
function $afebcb8f06c5af05$export$9448a5ef7e8c831a(a, b) {
    let c = null;
    return a.top > b.top && (c = {
        edge: "top",
        offset: 0
    }), a.left > b.left && (c = {
        edge: "left",
        offset: 0
    }), a.top + a.height < b.top + b.height && (c = {
        edge: "bottom",
        offset: $afebcb8f06c5af05$export$195604d042fd3f87(a.height - b.height, (0, $02dc23fb8a033d13$export$bc90872e265d166e))
    }), a.left + a.width < b.left + b.width && (c = {
        edge: "right",
        offset: $afebcb8f06c5af05$export$195604d042fd3f87(a.width - b.width, (0, $02dc23fb8a033d13$export$bc90872e265d166e))
    }), c;
}
function $afebcb8f06c5af05$export$e73c8bd0f20705a() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(a) {
        var b = 0 | 16 * Math.random(), c = "x" === a ? b : 8 | 3 & b;
        return c.toString(16);
    });
}
function $afebcb8f06c5af05$export$c2afdfb236bcd32() {
    const a = document.getElementsByClassName("memo");
    for (const b of a){
        let a = b.style.zIndex;
        b.style.zIndex = --a;
    }
}



let $524381aef3dfc454$var$activeMemo, $524381aef3dfc454$var$main, $524381aef3dfc454$var$canvas, $524381aef3dfc454$var$board, $524381aef3dfc454$var$selection, $524381aef3dfc454$var$currentMouse, $524381aef3dfc454$var$currentSize, $524381aef3dfc454$var$theme = "light";
/*
  Generic Event Handlers
*/ function $524381aef3dfc454$var$onMouseDown(a) {
    a.target === $524381aef3dfc454$var$board ? $524381aef3dfc454$var$handleBoardDragStart(a) : "drag" === a.target.classList[0] ? $524381aef3dfc454$var$handleMemoDragStart(a) : "resize" === a.target.classList[0] && $524381aef3dfc454$var$handleMemoResizeStart(a);
}
/*
  Memo Functions and Handlers
*/ function $524381aef3dfc454$var$createMemo(a, b, c, d) {
    const e = document.createElement("div");
    e.setAttribute("data-id", a), e.classList.add("memo"), e.style.top = `${c.top}px`, e.style.left = `${c.left}px`, e.style.width = `${d.width}px`, e.style.height = `${d.height}px`, e.style.zIndex = (0, $02dc23fb8a033d13$export$c995b89fa785e28);
    const f = document.createElement("textarea");
    f.classList.add("input"), f.setAttribute("placeholder", "Add a short memo..."), f.setAttribute("autocomplete", !0), b && (f.value = b), f.addEventListener("focus", function(a) {
        a.target.classList.add("active"), (0, $afebcb8f06c5af05$export$c2afdfb236bcd32)(), $524381aef3dfc454$var$activeMemo = a.target.parentNode, $524381aef3dfc454$var$activeMemo.style.zIndex = (0, $02dc23fb8a033d13$export$c995b89fa785e28);
    }), f.addEventListener("blur", function(a) {
        a.target.classList.remove("active");
    }, {
        passive: !1,
        useCapture: !1
    }), f.addEventListener("input", function(b) {
        const c = (0, $afebcb8f06c5af05$export$93d719890ad66653)("manifest_memos");
        c[a] = {
            ...c[a],
            text: b.target.value
        }, (0, $afebcb8f06c5af05$export$5aa524d86254b4f)("manifest_memos", c);
    }, {
        passive: !1,
        useCapture: !1
    }), e.appendChild(f);
    const g = document.createElement("div");
    g.classList.add("drag"), g.addEventListener("mousedown", $524381aef3dfc454$var$onMouseDown), g.addEventListener("touchstart", $524381aef3dfc454$var$onMouseDown), e.appendChild(g);
    const h = document.createElement("div");
    h.classList.add("close"), h.innerHTML = "\u2013", h.addEventListener("mouseup", $524381aef3dfc454$var$handleMemoClose), h.addEventListener("touchend", $524381aef3dfc454$var$handleMemoClose), e.appendChild(h);
    const i = document.createElement("div");
    return i.classList.add("resize"), i.addEventListener("mousedown", $524381aef3dfc454$var$onMouseDown), i.addEventListener("touchstart", $524381aef3dfc454$var$onMouseDown), e.appendChild(i), e;
}
function $524381aef3dfc454$var$handleMemoDragStart(a) {
    if (1 === a.which || a.touches) {
        (0, $afebcb8f06c5af05$export$c2afdfb236bcd32)(), $524381aef3dfc454$var$activeMemo = a.target.parentNode, $524381aef3dfc454$var$activeMemo.classList.add("active"), $524381aef3dfc454$var$activeMemo.style.zIndex = (0, $02dc23fb8a033d13$export$c995b89fa785e28);
        const b = $524381aef3dfc454$var$activeMemo.querySelectorAll(".input")[0];
        b.blur(), a.target.style.backgroundColor = "var(--gray)", a.target.style.cursor = "grabbing", document.body.style.cursor = "grabbing";
        const c = a.touches && 0 < a.touches.length ? (0, $afebcb8f06c5af05$export$195604d042fd3f87)(a.touches[0].clientX, (0, $02dc23fb8a033d13$export$bc90872e265d166e)) : (0, $afebcb8f06c5af05$export$195604d042fd3f87)(a.clientX, (0, $02dc23fb8a033d13$export$bc90872e265d166e)), d = a.touches && 0 < a.touches.length ? (0, $afebcb8f06c5af05$export$195604d042fd3f87)(a.touches[0].clientY, (0, $02dc23fb8a033d13$export$bc90872e265d166e)) : (0, $afebcb8f06c5af05$export$195604d042fd3f87)(a.clientY, (0, $02dc23fb8a033d13$export$bc90872e265d166e));
        $524381aef3dfc454$var$currentMouse = {
            x: c,
            y: d
        }, document.addEventListener("mousemove", $524381aef3dfc454$var$handleMemoDragMove, {
            passive: !1,
            useCapture: !1
        }), document.addEventListener("touchmove", $524381aef3dfc454$var$handleMemoDragMove, {
            passive: !1,
            useCapture: !1
        }), document.addEventListener("mouseup", $524381aef3dfc454$var$handleMemoDragEnd, {
            passive: !1,
            useCapture: !1
        }), document.addEventListener("touchcancel", $524381aef3dfc454$var$handleMemoDragEnd, {
            passive: !1,
            useCapture: !1
        }), document.addEventListener("touchend", $524381aef3dfc454$var$handleMemoDragEnd, {
            passive: !1,
            useCapture: !1
        });
    }
}
function $524381aef3dfc454$var$handleMemoDragMove(a) {
    const b = $524381aef3dfc454$var$activeMemo.classList.contains("active");
    if (b) {
        const b = a.touches && 0 < a.touches.length ? (0, $afebcb8f06c5af05$export$195604d042fd3f87)(a.touches[0].clientX, (0, $02dc23fb8a033d13$export$bc90872e265d166e)) : (0, $afebcb8f06c5af05$export$195604d042fd3f87)(a.clientX, (0, $02dc23fb8a033d13$export$bc90872e265d166e)), c = a.touches && 0 < a.touches.length ? (0, $afebcb8f06c5af05$export$195604d042fd3f87)(a.touches[0].clientY, (0, $02dc23fb8a033d13$export$bc90872e265d166e)) : (0, $afebcb8f06c5af05$export$195604d042fd3f87)(a.clientY, (0, $02dc23fb8a033d13$export$bc90872e265d166e));
        $524381aef3dfc454$var$activeMemo.style.top = `${$524381aef3dfc454$var$activeMemo.offsetTop - ($524381aef3dfc454$var$currentMouse.y - c)}px`, $524381aef3dfc454$var$activeMemo.style.left = `${$524381aef3dfc454$var$activeMemo.offsetLeft - ($524381aef3dfc454$var$currentMouse.x - b)}px`, $524381aef3dfc454$var$currentMouse = {
            x: b,
            y: c
        };
    }
}
function $524381aef3dfc454$var$handleMemoDragEnd(a) {
    const b = (0, $afebcb8f06c5af05$export$9448a5ef7e8c831a)($524381aef3dfc454$var$board.getBoundingClientRect(), $524381aef3dfc454$var$activeMemo.getBoundingClientRect()), c = a.touches && 0 < a.touches.length ? (0, $afebcb8f06c5af05$export$195604d042fd3f87)(a.touches[0].clientX, (0, $02dc23fb8a033d13$export$bc90872e265d166e)) : (0, $afebcb8f06c5af05$export$195604d042fd3f87)(a.clientX, (0, $02dc23fb8a033d13$export$bc90872e265d166e)), d = a.touches && 0 < a.touches.length ? (0, $afebcb8f06c5af05$export$195604d042fd3f87)(a.touches[0].clientY, (0, $02dc23fb8a033d13$export$bc90872e265d166e)) : (0, $afebcb8f06c5af05$export$195604d042fd3f87)(a.clientY, (0, $02dc23fb8a033d13$export$bc90872e265d166e));
    let e = $524381aef3dfc454$var$activeMemo.offsetTop - ($524381aef3dfc454$var$currentMouse.y - d), f = $524381aef3dfc454$var$activeMemo.offsetLeft - ($524381aef3dfc454$var$currentMouse.x - c);
    b && ("top" === b.edge ? e = b.offset : "bottom" === b.edge ? e = b.offset : "left" === b.edge ? f = b.offset : "right" === b.edge && (f = b.offset)), $524381aef3dfc454$var$activeMemo.style.top = `${e}px`, $524381aef3dfc454$var$activeMemo.style.left = `${f}px`, $524381aef3dfc454$var$activeMemo.classList.remove("active");
    const g = $524381aef3dfc454$var$activeMemo.querySelectorAll(".drag")[0];
    g.style.cursor = "grab", g.style.backgroundColor = "transparent";
    const h = $524381aef3dfc454$var$activeMemo.querySelectorAll(".input")[0];
    h.focus();
    const i = $524381aef3dfc454$var$activeMemo.dataset.id, j = (0, $afebcb8f06c5af05$export$93d719890ad66653)("manifest_memos");
    j[i] = {
        ...j[i],
        position: {
            top: e,
            left: f
        }
    }, (0, $afebcb8f06c5af05$export$5aa524d86254b4f)("manifest_memos", j), document.body.style.cursor = null, $524381aef3dfc454$var$activeMemo = null, $524381aef3dfc454$var$currentMouse = null, document.removeEventListener("mousemove", $524381aef3dfc454$var$handleMemoDragMove), document.removeEventListener("touchmove", $524381aef3dfc454$var$handleMemoDragMove), document.removeEventListener("mouseup", $524381aef3dfc454$var$handleMemoDragEnd), document.removeEventListener("touchcancel", $524381aef3dfc454$var$handleMemoDragEnd), document.removeEventListener("touchend", $524381aef3dfc454$var$handleMemoDragEnd);
}
function $524381aef3dfc454$var$handleMemoClose(a) {
    if ((0, $afebcb8f06c5af05$export$715f9d76bb8c1fea)("Are you sure you want to remove this memo?")) {
        const b = a.target.parentNode.dataset.id, c = (0, $afebcb8f06c5af05$export$93d719890ad66653)("manifest_memos");
        delete c[b], (0, $afebcb8f06c5af05$export$5aa524d86254b4f)("manifest_memos", c), $524381aef3dfc454$var$board.removeChild(a.target.parentNode);
    }
}
function $524381aef3dfc454$var$handleMemoResizeStart(a) {
    if (1 === a.which || a.touches) {
        (0, $afebcb8f06c5af05$export$c2afdfb236bcd32)(), $524381aef3dfc454$var$activeMemo = a.target.parentNode, $524381aef3dfc454$var$activeMemo.classList.add("active"), $524381aef3dfc454$var$activeMemo.style.zIndex = (0, $02dc23fb8a033d13$export$c995b89fa785e28);
        const b = $524381aef3dfc454$var$activeMemo.querySelectorAll(".input")[0];
        b.blur(), document.body.style.cursor = "nw-resize", a.target.style.backgroundColor = "var(--gray)";
        const c = a.touches && 0 < a.touches.length ? (0, $afebcb8f06c5af05$export$195604d042fd3f87)(a.touches[0].clientX, (0, $02dc23fb8a033d13$export$bc90872e265d166e)) : (0, $afebcb8f06c5af05$export$195604d042fd3f87)(a.clientX, (0, $02dc23fb8a033d13$export$bc90872e265d166e)), d = a.touches && 0 < a.touches.length ? (0, $afebcb8f06c5af05$export$195604d042fd3f87)(a.touches[0].clientY, (0, $02dc23fb8a033d13$export$bc90872e265d166e)) : (0, $afebcb8f06c5af05$export$195604d042fd3f87)(a.clientY, (0, $02dc23fb8a033d13$export$bc90872e265d166e)), e = $524381aef3dfc454$var$activeMemo.getBoundingClientRect(), f = parseInt(e.width, 10), g = parseInt(e.height, 10);
        $524381aef3dfc454$var$currentMouse = {
            x: c,
            y: d
        }, $524381aef3dfc454$var$currentSize = {
            width: f,
            height: g
        }, document.addEventListener("mousemove", $524381aef3dfc454$var$handleMemoResizeMove, {
            passive: !1,
            useCapture: !1
        }), document.addEventListener("touchmove", $524381aef3dfc454$var$handleMemoResizeMove, {
            passive: !1,
            useCapture: !1
        }), document.addEventListener("mouseup", $524381aef3dfc454$var$handleMemoResizeEnd, {
            passive: !1,
            useCapture: !1
        }), document.addEventListener("touchcancel", $524381aef3dfc454$var$handleMemoResizeEnd, {
            passive: !1,
            useCapture: !1
        }), document.addEventListener("touchend", $524381aef3dfc454$var$handleMemoResizeEnd, {
            passive: !1,
            useCapture: !1
        });
    }
}
function $524381aef3dfc454$var$handleMemoResizeMove(a) {
    const b = $524381aef3dfc454$var$activeMemo.classList.contains("active");
    if (b) {
        const b = a.touches && 0 < a.touches.length ? (0, $afebcb8f06c5af05$export$195604d042fd3f87)(a.touches[0].clientX, (0, $02dc23fb8a033d13$export$bc90872e265d166e)) : (0, $afebcb8f06c5af05$export$195604d042fd3f87)(a.clientX, (0, $02dc23fb8a033d13$export$bc90872e265d166e)), c = a.touches && 0 < a.touches.length ? (0, $afebcb8f06c5af05$export$195604d042fd3f87)(a.touches[0].clientY, (0, $02dc23fb8a033d13$export$bc90872e265d166e)) : (0, $afebcb8f06c5af05$export$195604d042fd3f87)(a.clientY, (0, $02dc23fb8a033d13$export$bc90872e265d166e)), d = $524381aef3dfc454$var$currentSize.width + (b - $524381aef3dfc454$var$currentMouse.x) - 2, e = $524381aef3dfc454$var$currentSize.height + (c - $524381aef3dfc454$var$currentMouse.y) - 2;
        $524381aef3dfc454$var$activeMemo.style.width = `${d}px`, $524381aef3dfc454$var$activeMemo.style.height = `${e}px`;
    }
}
function $524381aef3dfc454$var$handleMemoResizeEnd(a) {
    const b = a.touches && 0 < a.touches.length ? (0, $afebcb8f06c5af05$export$195604d042fd3f87)(a.touches[0].clientX, (0, $02dc23fb8a033d13$export$bc90872e265d166e)) : (0, $afebcb8f06c5af05$export$195604d042fd3f87)(a.clientX, (0, $02dc23fb8a033d13$export$bc90872e265d166e)), c = a.touches && 0 < a.touches.length ? (0, $afebcb8f06c5af05$export$195604d042fd3f87)(a.touches[0].clientY, (0, $02dc23fb8a033d13$export$bc90872e265d166e)) : (0, $afebcb8f06c5af05$export$195604d042fd3f87)(a.clientY, (0, $02dc23fb8a033d13$export$bc90872e265d166e)), d = $524381aef3dfc454$var$currentSize.width + (b - $524381aef3dfc454$var$currentMouse.x) - 2, e = $524381aef3dfc454$var$currentSize.height + (c - $524381aef3dfc454$var$currentMouse.y) - 2;
    $524381aef3dfc454$var$activeMemo.style.width = `${d}px`, $524381aef3dfc454$var$activeMemo.style.height = `${e}px`;
    const f = (0, $afebcb8f06c5af05$export$9448a5ef7e8c831a)($524381aef3dfc454$var$board.getBoundingClientRect(), $524381aef3dfc454$var$activeMemo.getBoundingClientRect());
    if (f) {
        let a = $524381aef3dfc454$var$activeMemo.offsetTop, b = $524381aef3dfc454$var$activeMemo.offsetLeft;
        "top" === f.edge ? a = f.offset : "bottom" === f.edge ? a = f.offset : "left" === f.edge ? b = f.offset : "right" === f.edge && (b = f.offset), $524381aef3dfc454$var$activeMemo.style.top = `${a}px`, $524381aef3dfc454$var$activeMemo.style.left = `${b}px`;
    }
    const g = $524381aef3dfc454$var$activeMemo.querySelectorAll(".resize")[0];
    g.style.cursor = "nw-resize", g.style.backgroundColor = "transparent", $524381aef3dfc454$var$activeMemo.classList.remove("active");
    const h = $524381aef3dfc454$var$activeMemo.querySelectorAll(".input")[0];
    h.focus();
    const i = $524381aef3dfc454$var$activeMemo.dataset.id, j = (0, $afebcb8f06c5af05$export$93d719890ad66653)("manifest_memos");
    j[i] = {
        ...j[i],
        size: {
            width: d,
            height: e
        }
    }, (0, $afebcb8f06c5af05$export$5aa524d86254b4f)("manifest_memos", j), document.body.style.cursor = null, $524381aef3dfc454$var$activeMemo = null, $524381aef3dfc454$var$currentSize = null, document.removeEventListener("mousemove", $524381aef3dfc454$var$handleMemoResizeMove, {
        passive: !1,
        useCapture: !1
    }), document.removeEventListener("touchmove", $524381aef3dfc454$var$handleMemoResizeMove, {
        passive: !1,
        useCapture: !1
    }), document.removeEventListener("mouseup", $524381aef3dfc454$var$handleMemoResizeEnd, {
        passive: !1,
        useCapture: !1
    }), document.removeEventListener("touchcancel", $524381aef3dfc454$var$handleMemoResizeEnd, {
        passive: !1,
        useCapture: !1
    }), document.removeEventListener("touchend", $524381aef3dfc454$var$handleMemoResizeEnd, {
        passive: !1,
        useCapture: !1
    });
}
/*
  Board Functions and Handlers
*/ function $524381aef3dfc454$var$handleBoardDragStart(a) {
    if (1 === a.which || a.touches) {
        document.body.style.cursor = "crosshair", $524381aef3dfc454$var$board.classList.add("active");
        const b = $524381aef3dfc454$var$board.getBoundingClientRect(), c = a.touches && 0 < a.touches.length ? (0, $afebcb8f06c5af05$export$195604d042fd3f87)(a.touches[0].clientX - b.left, (0, $02dc23fb8a033d13$export$bc90872e265d166e)) : (0, $afebcb8f06c5af05$export$195604d042fd3f87)(a.clientX - b.left, (0, $02dc23fb8a033d13$export$bc90872e265d166e)), d = a.touches && 0 < a.touches.length ? (0, $afebcb8f06c5af05$export$195604d042fd3f87)(a.touches[0].clientY - b.top, (0, $02dc23fb8a033d13$export$bc90872e265d166e)) : (0, $afebcb8f06c5af05$export$195604d042fd3f87)(a.clientY - b.top, (0, $02dc23fb8a033d13$export$bc90872e265d166e));
        $524381aef3dfc454$var$currentMouse = {
            x: c,
            y: d
        }, $524381aef3dfc454$var$selection = document.createElement("div"), $524381aef3dfc454$var$selection.setAttribute("id", "selection"), $524381aef3dfc454$var$selection.style.zIndex = (0, $02dc23fb8a033d13$export$8da1753993efc39a), $524381aef3dfc454$var$board.appendChild($524381aef3dfc454$var$selection), document.addEventListener("mousemove", $524381aef3dfc454$var$handleBoardDragMove), document.addEventListener("touchmove", $524381aef3dfc454$var$handleBoardDragMove), document.addEventListener("mouseup", $524381aef3dfc454$var$handleBoardDragEnd), document.addEventListener("touchcancel", $524381aef3dfc454$var$handleBoardDragEnd), document.addEventListener("touchend", $524381aef3dfc454$var$handleBoardDragEnd);
    }
}
function $524381aef3dfc454$var$handleBoardDragMove(a) {
    const b = $524381aef3dfc454$var$board.getBoundingClientRect(), c = a.touches && 0 < a.touches.length ? (0, $afebcb8f06c5af05$export$195604d042fd3f87)(a.touches[0].clientX - b.left, (0, $02dc23fb8a033d13$export$bc90872e265d166e)) : (0, $afebcb8f06c5af05$export$195604d042fd3f87)(a.clientX - b.left, (0, $02dc23fb8a033d13$export$bc90872e265d166e)), d = a.touches && 0 < a.touches.length ? (0, $afebcb8f06c5af05$export$195604d042fd3f87)(a.touches[0].clientY - b.top, (0, $02dc23fb8a033d13$export$bc90872e265d166e)) : (0, $afebcb8f06c5af05$export$195604d042fd3f87)(a.clientY - b.top, (0, $02dc23fb8a033d13$export$bc90872e265d166e)), e = 0 > d - $524381aef3dfc454$var$currentMouse.y ? d : $524381aef3dfc454$var$currentMouse.y, f = 0 > c - $524381aef3dfc454$var$currentMouse.x ? c : $524381aef3dfc454$var$currentMouse.x, g = Math.abs(c - $524381aef3dfc454$var$currentMouse.x) + 1, h = Math.abs(d - $524381aef3dfc454$var$currentMouse.y) + 1;
    $524381aef3dfc454$var$selection.style.top = `${e}px`, $524381aef3dfc454$var$selection.style.left = `${f}px`, $524381aef3dfc454$var$selection.style.width = `${g}px`, $524381aef3dfc454$var$selection.style.height = `${h}px`;
}
function $524381aef3dfc454$var$handleBoardDragEnd() {
    const a = $524381aef3dfc454$var$board.getBoundingClientRect(), b = $524381aef3dfc454$var$selection.getBoundingClientRect(), c = b.width - 2, d = b.height - 2;
    let e = b.top - a.top, f = b.left - a.left;
    const g = (0, $afebcb8f06c5af05$export$9448a5ef7e8c831a)(a, b);
    if (g && ("top" === g.edge ? e = g.offset : "bottom" === g.edge ? e = g.offset : "left" === g.edge ? f = g.offset : "right" === g.edge && (f = g.offset)), 80 <= c && 80 <= d) {
        const a = (0, $afebcb8f06c5af05$export$e73c8bd0f20705a)(), b = $524381aef3dfc454$var$createMemo(a, null, {
            top: e,
            left: f
        }, {
            width: c,
            height: d
        });
        $524381aef3dfc454$var$board.appendChild(b);
        const g = b.querySelectorAll(".input")[0];
        g.focus();
        const h = (0, $afebcb8f06c5af05$export$93d719890ad66653)("manifest_memos");
        h[a] = {
            text: null,
            position: {
                top: e,
                left: f
            },
            size: {
                width: c,
                height: d
            }
        }, (0, $afebcb8f06c5af05$export$5aa524d86254b4f)("manifest_memos", h), $524381aef3dfc454$var$activeMemo = b;
    }
    document.body.style.cursor = null, $524381aef3dfc454$var$board.classList.remove("active"), $524381aef3dfc454$var$board.removeChild($524381aef3dfc454$var$selection), document.removeEventListener("mousemove", $524381aef3dfc454$var$handleBoardDragMove, {
        passive: !1,
        useCapture: !1
    }), document.removeEventListener("touchmove", $524381aef3dfc454$var$handleBoardDragMove, {
        passive: !1,
        useCapture: !1
    }), document.removeEventListener("mouseup", $524381aef3dfc454$var$handleBoardDragEnd, {
        passive: !1,
        useCapture: !1
    }), document.removeEventListener("touchcancel", $524381aef3dfc454$var$handleBoardDragEnd, {
        passive: !1,
        useCapture: !1
    }), document.removeEventListener("touchend", $524381aef3dfc454$var$handleBoardDragEnd, {
        passive: !1,
        useCapture: !1
    });
}
/*
  App Functions
*/ function $524381aef3dfc454$var$toggleTheme() {
    const a = document.querySelector("body");
    // Redraw the canvas
    "light" === $524381aef3dfc454$var$theme ? (a.classList.add("dark"), $524381aef3dfc454$var$theme = "dark", (0, $afebcb8f06c5af05$export$5aa524d86254b4f)("manifest_theme", "dark")) : (a.classList.remove("dark"), $524381aef3dfc454$var$theme = "light", (0, $afebcb8f06c5af05$export$5aa524d86254b4f)("manifest_theme", "light")), $524381aef3dfc454$var$onResize();
}
function $524381aef3dfc454$var$handleTheme() {
    const a = document.querySelector("body"), b = (0, $afebcb8f06c5af05$export$93d719890ad66653)("manifest_theme");
    // Prefer saved preference over OS preference
    return b ? void ("dark" === b ? (a.classList.add("dark"), $524381aef3dfc454$var$theme = "dark", (0, $afebcb8f06c5af05$export$5aa524d86254b4f)("manifest_theme", "dark")) : (a.classList.remove("dark"), $524381aef3dfc454$var$theme = "light", (0, $afebcb8f06c5af05$export$5aa524d86254b4f)("manifest_theme", "light"))) : void (window.matchMedia("(prefers-color-scheme: dark)").matches && (a.classList.add("dark"), $524381aef3dfc454$var$theme = "dark"));
}
function $524381aef3dfc454$var$onKeydown(a) {
    ("KeyT" === a.code || 84 === a.keyCode) && a.altKey && $524381aef3dfc454$var$toggleTheme();
}
function $524381aef3dfc454$var$onResize() {
    $524381aef3dfc454$var$main.style.width = `${window.innerWidth}px`, $524381aef3dfc454$var$main.style.height = `${window.innerHeight}px`;
    const a = window.innerWidth - (0, $02dc23fb8a033d13$export$aaacef11acc9e4f6) - 1, b = window.innerHeight - (0, $02dc23fb8a033d13$export$aaacef11acc9e4f6) + 1;
    $524381aef3dfc454$var$canvas.setAttribute("width", a), $524381aef3dfc454$var$canvas.setAttribute("height", b), $524381aef3dfc454$var$canvas.style.top = `${(0, $02dc23fb8a033d13$export$aaacef11acc9e4f6) / 2}px`, $524381aef3dfc454$var$canvas.style.left = `${(0, $02dc23fb8a033d13$export$aaacef11acc9e4f6) / 2}px`, $524381aef3dfc454$var$canvas.style.width = `${a}px`, $524381aef3dfc454$var$canvas.style.height = `${b}px`;
    const c = $524381aef3dfc454$var$canvas.getContext("2d");
    for(let d = 0; d <= a; d += (0, $02dc23fb8a033d13$export$bc90872e265d166e))for(let a = 0; a <= b; a += (0, $02dc23fb8a033d13$export$bc90872e265d166e))c.fillStyle = "light" === $524381aef3dfc454$var$theme ? "rgba(0, 0, 0, 0.5)" : "rgba(255, 255, 255, 0.4)", c.beginPath(), c.rect(d, a, 1, 1), c.fill();
    $524381aef3dfc454$var$board.style.top = `${(0, $02dc23fb8a033d13$export$aaacef11acc9e4f6) / 2}px`, $524381aef3dfc454$var$board.style.left = `${(0, $02dc23fb8a033d13$export$aaacef11acc9e4f6) / 2}px`, $524381aef3dfc454$var$board.style.width = `${a}px`, $524381aef3dfc454$var$board.style.height = `${b}px`, $524381aef3dfc454$var$currentMouse = null, $524381aef3dfc454$var$currentSize = null;
}
function $524381aef3dfc454$var$onLoad() {
    $524381aef3dfc454$var$handleTheme(), $524381aef3dfc454$var$main = document.createElement("main"), $524381aef3dfc454$var$main.setAttribute("id", "app"), $524381aef3dfc454$var$canvas = document.createElement("canvas"), $524381aef3dfc454$var$canvas.setAttribute("id", "grid"), $524381aef3dfc454$var$board = document.createElement("section"), $524381aef3dfc454$var$board.setAttribute("id", "board"), $524381aef3dfc454$var$board.addEventListener("mousedown", $524381aef3dfc454$var$onMouseDown, {
        passive: !1,
        useCapture: !1
    }), $524381aef3dfc454$var$board.addEventListener("touchstart", $524381aef3dfc454$var$onMouseDown, {
        passive: !1,
        useCapture: !1
    }), $524381aef3dfc454$var$main.appendChild($524381aef3dfc454$var$canvas), $524381aef3dfc454$var$main.appendChild($524381aef3dfc454$var$board), document.body.appendChild($524381aef3dfc454$var$main), document.body.addEventListener("touchmove", function(a) {
        a.preventDefault();
    }, {
        passive: !1,
        useCapture: !1
    });
    const a = (0, $afebcb8f06c5af05$export$93d719890ad66653)("manifest_memos");
    if (!a || 0 === Object.keys(a).length) {
        const a = $524381aef3dfc454$var$createMemo((0, $02dc23fb8a033d13$export$da9e2c336eb0e98e).id, (0, $02dc23fb8a033d13$export$da9e2c336eb0e98e).text, (0, $02dc23fb8a033d13$export$da9e2c336eb0e98e).position, (0, $02dc23fb8a033d13$export$da9e2c336eb0e98e).size);
        $524381aef3dfc454$var$board.appendChild(a);
        const b = {};
        b[(0, $02dc23fb8a033d13$export$da9e2c336eb0e98e).id] = {
            text: (0, $02dc23fb8a033d13$export$da9e2c336eb0e98e).text,
            position: (0, $02dc23fb8a033d13$export$da9e2c336eb0e98e).position,
            size: (0, $02dc23fb8a033d13$export$da9e2c336eb0e98e).size
        }, (0, $afebcb8f06c5af05$export$5aa524d86254b4f)("manifest_memos", b);
    } else for (const b of Object.keys(a)){
        const c = $524381aef3dfc454$var$createMemo(b, a[b].text, a[b].position, a[b].size);
        $524381aef3dfc454$var$board.appendChild(c);
    }
    $524381aef3dfc454$var$onResize();
}
window.addEventListener("resize", $524381aef3dfc454$var$onResize), window.addEventListener("load", $524381aef3dfc454$var$onLoad), window.addEventListener("keydown", $524381aef3dfc454$var$onKeydown);

})();
//# sourceMappingURL=index.cec0f92a.js.map
